import React, { useContext } from 'react';
import {
	IRestaurantFullInfoContext,
	RestaurantFullInfoContext,
} from '../../../../../../../restaurantFullInfoState/restaurantFullInfoContext';
import Text from 'components/Text/Text';
import style from './InformationMessagesField.module.scss';

export const InformationMessagesField = () => {
	const { androidWatches } = useContext<IRestaurantFullInfoContext>(RestaurantFullInfoContext);

	return (
		<div className={style.container}>
			<Text
				translationNameSpace="form"
				translationKey="informationMessagesLabel"
				theme="neutralLight"
				size="xs"
			/>
			<div className={style.informationMessagesList}>
				{androidWatches?.informationMessages.length ? (
					androidWatches.informationMessages.map((el) => {
						return (
							<div key={el} className={style.item}>
								<div className={style.dot} />
								<Text translationKey={el} asFragment={true} />
							</div>
						);
					})
				) : (
					<Text translationNameSpace="form" translationKey="-" />
				)}
			</div>
		</div>
	);
};
